import { CalculateVenue } from '@/domain/impact-calculate-venue/entities/calculate-venue.entity';
import { EMPTY_CALCULATE_VENUE_CO2 } from '@/domain/impact-calculate-venue/entities/calculate-venue-co2.entity';
import { EMPTY_CALCULATE_VENUE_ENV } from '@/domain/impact-calculate-venue/entities/calculate-venue-env.entity';
import { EMPTY_CALCULATE_VENUE_ESS } from '@/domain/impact-calculate-venue/entities/calculate-venue-ess.entity';

import { TopicsGlobalScoreData } from '../entities/calculate.entity';

export function prepareTopicsGlobalScoreDataVenue(
  calculate: CalculateVenue | null,
): TopicsGlobalScoreData {
  const co2 = calculate?.co2 || EMPTY_CALCULATE_VENUE_CO2;
  const env = calculate?.env || EMPTY_CALCULATE_VENUE_ENV;
  const ess = calculate?.ess || EMPTY_CALCULATE_VENUE_ESS;
  return {
    projectMode: 'venue',
    co2: {
      scoreLetter: co2.global.scoreLetter,
      score: co2.global.score,
      kgeCO2ByParticipant: co2.global.kgeCO2ByParticipant,
    },
    env: {
      scoreLetter: env.global.scoreLetter,
      score: env.global.score,
      maxScore: env.global.maxScore,
    },
    ess: {
      scoreLetter: ess.global.scoreLetter,
      score: ess.global.score,
      maxScore: ess.global.maxScore,
    },
  };
}
